import React from "react";
import Footer from "./Essentials/Footer";
import Navbar from "./Essentials/Navbar";
import "./Css/Stylesheet.css";

function Updates() {
  const [updates, setUpdates] = React.useState("");
  fetch("https://rohitpidishetty.github.io/NFRAC_Projects/Updates.json")
    .then(res => res.json())
    .then(
      news => {
        setUpdates(news);
      },
      [updates]
    );
  return (

    <div>
      <Navbar />
      <div className="highlights">
        <p>What's New</p>
        <div
          style={{
            height: "unset"
          }}
          className="updateSection"
        >
          {updates &&
            updates.news.map((news, idx) => {
              return (
                <p
                  key={idx}
                  onClick={() => {
                    window.open(news.link, "_self");
                  }}
                  className="news"
                >
                  <p className="date">
                    {news.date}
                  </p>
                  <p className="title">
                    {news.title}
                  </p>
                </p>
              );
            })}
        </div>
      </div>
    </div>



  );
}

export default Updates;
